export const API_URL = "https://checkout.franquezatech.com";
export const LOCAL_URL = "https://pipedrive-extensions.franquezatech.com";
